import type { StepperDesignTokens } from '@primeuix/themes/types/stepper';

/**
 * Stepper component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/stepper/index.ts
 *
 * Component documentation:
 * https://primeng.org/stepper
 */
export const stepperComponentTokens: Partial<StepperDesignTokens> = {
  colorScheme: {
    light: {
      stepNumber: {
        background: '{surface.50}',
        borderColor: '{primary.color}',
        color: '{text.color}',
        activeBackground: '{primary.color}',
        activeBorderColor: '{primary.color}',
        activeColor: '{white}',
      },
      separator: {
        activeBackground: '{primary.color}',
      },
      stepTitle: {
        color: '{text.color}',
        activeColor: '{text.color}',
      },
      stepHeader: {
        focusRing: {
          color: '{primary.color}',
        },
      },
      steppanel: {
        background: 'transparent',
      },
    },
  },
};
